var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:" bg-brand-secondary min-h-full"},[_c('div',{staticClass:"max-w-6xl mx-auto"},[_c('NavRow'),_c('div',{staticClass:"mx-12 mt-10 lg:mx-0 lg:mt-0"},[_c('LoginRegister',{on:{"successful":_vm.goDash}})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }